import React from 'react';
import {
  Box,
  Card,
  CardContent,
  Grid,
  Typography,
  colors,
  makeStyles,
  Button,
} from '@material-ui/core';

import MoneyIcon from '@material-ui/icons/Money';

import { Link } from 'react-router-dom'

const useStyles = makeStyles((theme) => ({
  root: {
    height: '100%'
  },
  avatar: {
    backgroundColor: colors.red[600],
    height: 56,
    width: 56
  },
  differenceIcon: {
    color: colors.red[900]
  },
  differenceValue: {
    color: colors.red[900],
    marginRight: theme.spacing(1)
  }
}));

const MyShares = () => {
  const classes = useStyles();


  const topShareholdersAmount = [63, 15, 21, 3, 3, 3]

  const myShares = 63
  const totalShares = topShareholdersAmount.reduce((a, b) => a + b, 0)

  return (
    <Card
      className={classes.root}
      align="center"
    >
      <CardContent >
        <Grid
          container
          justify="space-between"
          spacing={3}
        >
          <Grid item xs={12}>
            <Typography
              color="textSecondary"
              gutterBottom
              variant="h6"
            >
              My Shares
            </Typography>
          </Grid >

          <Grid item xs={12}>
            <Typography
            >
              In this repository, you own {myShares} shares out of a pool of {totalShares} ({(100*myShares/totalShares).toFixed(2)+"%"})
            </Typography>
          </Grid>

          <Grid item xs={12}>
            <Box m={3} color="red" display="inline"/>
            <Button startIcon={<MoneyIcon />} variant="outlined" component={Link} to="management?user=plasmatech8">
              See my recent share activity
            </Button>
          </Grid>
        </Grid>

      </CardContent>
    </Card>
  );
};

export default MyShares;
